<!-- D3 NP-300 AC1/AC3: who has this Survey Product open now. Initials, with the full name on hover and for screen readers. -->
<section *ngIf="state !== 'unavailable'" class="collaboration-presence" aria-label="People with this Survey Product open" data-testid="presence">
  <span class="presence-label">Active now</span>
  <ul class="presence-list">
    <li
      *ngFor="let person of present; trackBy: trackPerson"
      class="presence-avatar"
      [class.presence-editing]="person.activity === 'Editing'"
      [class.presence-self]="person.isSelf"
      [attr.title]="describe(person)"
      [attr.aria-label]="describe(person)"
      tabindex="0"
      data-testid="presence-avatar"
    >
      <span aria-hidden="true">{{ initials(person.name) }}</span>
    </li>
  </ul>
  <span class="presence-status" role="status" aria-live="polite" data-testid="presence-status">{{ statusText }}</span>
</section>
